<script lang="ts">
    import NauiInput from "../../naui/atoms/NauiInput.svelte";
    import NauiTextarea from "../../naui/atoms/NauiTextarea.svelte";
    import {ItemPrice} from "../../interfaces/item-price.class";
    import {createEventDispatcher} from "svelte";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import NauiTag from "../../naui/atoms/NauiTag.svelte";
    import NauiField from "../../naui/atoms/NauiField.svelte";
    import {currency, percent} from "../../utils";

    export let item: ItemPrice;
    export let editable: boolean = false;
    export let canApprove: boolean = false;

    export let currentPage = 1;
    export let itemsPerPage = 10;
    export let nPages = 5;
    export let itemsPerPageOptions = [];

    const dispatcher = createEventDispatcher();

    function reject() {
        dispatcher('sendApproval', {
            id: item.id,
            status: {
                label: 'RECHAZAR',
                action: {
                    label: 'Rechazado',
                    value: 'rechazado'
                }

            }
        })
    }

    function approve() {
        dispatcher('sendApproval', {
            id: item.id,
            status: {
                label: 'APROBAR',
                action: {
                    label: 'Aprobado',
                    value: 'aprobado'
                }
            }
        })
    }

    function showApproval() {
        if (item.approvalStatus?.value != 'pendiente') {
            dispatcher('showApproval', {
                id: item.id,
                date: item.approvalDate,
                status: {
                    action: item.approvalStatus
                },
                user: item.gaUser,
                comment: item.gaComment
            });
        }
    }

    

</script>

<div class="p-1 radius shadow mb-15">
    <!--
    <code>
        id: {item.id};<br>
        isCompleted: {item.isCompleted};<br>
        toApprove: {item.toApprove};<br>
        valid: {item.valid};<br>
    </code>
    <br>
    -->
    <!--div class="number">
        {item.number}
    </div-->

    <div class="price-container grid-7-5 gap-2">
        <div>
            <div class="mb-iii" style="font-weight: 600">
                Datos generales del producto
            </div>
            <div class="mb-1 grid-12 gap-1 ">
                <NauiField label="Item"
                           className="col-2"
                           value={item.number ? item.number : ''}/>
                <NauiInput className="mb-1 col-10"
                           label="Nombre solicitado por el cliente"
                           isDisabled={true}
                           value={item.name}/>
            </div>
            <NauiInput className="mb-1"
                       label="Código | Descripción BBRAUN"
                       isDisabled={true}
                       value="{item?.product?.label}"/>
            <div class="grid-3 gap-1 mb-15">
                <NauiInput label="Unidad de medida (UM)"
                           isDisabled={true}
                           value={item?.product?.measurement_unit}/>
                <NauiInput label="Cantidad por UM"
                           isDisabled={true}
                           value={item?.product?.quantity_by_um}/>
                <NauiInput label="Cantidad solicitada (Unds)"
                           isDisabled={true}
                           value={item?.quantity}/>
            </div>
            <div class="mt-15 mb-1" style="font-weight: 600">Datos complementarios</div>

            <div class="grid-2 gap-1">
                {#if item.product}
                    <div class="back-gray p-ii radius">
                        <table>
                            {#if item.product.sap}
                                <thead>
                                <tr>
                                    <th colspan="4"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td colspan="3">Precio actual cargado en SAP</td>
                                    <td>{currency.format(item.product?.sap?.current)}</td>
                                </tr>
                                <tr>
                                    <td colspan="3">Precio anterior cargado en SAP</td>
                                    <td>{currency.format(item.product?.sap?.previous)}</td>
                                </tr>
                                <tr>
                                    <td colspan="3">% Incremento sobre precio vendido año anterior</td>
                                    <td>{percent.format(item.IncreasePriceSoldPreviousYear)}
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3">Precio vendido año anterior</td>
                                    <td>{currency.format(item.product?.sap?.priceSold)}</td>
                                </tr>
                                <!-- {#if item.increasePriceSold }
                                    <tr>
                                        <td colspan="3">% Incremento Precio Vendido</td>
                                        <td>{percent.format(item.increasePriceSold)}</td>
                                    </tr>
                                {/if} -->
                                </tbody>
                            {/if}
                            {#if item.product.abc}
                                <tbody>
                                <tr>
                                    <td rowspan="2">
                                        <div class="pt-1">
                                            Lista precios
                                        </div>
                                    </td>
                                    <td class="text-c">A</td>
                                    <td class="text-c">B</td>
                                    <td class="text-c">C</td>
                                </tr>
                                <tr>
                                    <td>{currency.format(item.product.abc?.A | 0)}</td>
                                    <td>{currency.format(item.product.abc?.B | 0)}</td>
                                    <td>{currency.format(item.product.abc?.C | 0)}</td>
                                </tr>
                                </tbody>
                            {/if}
                        </table>
                    </div>
                {/if}
                <div class="grid-2 gap-ii">
                    <div>
                        <NauiField label="Precio techo"
                                   className="mb-1"
                                   value={currency.format(item.roof)}/>
                        {#if !editable || item.isDisabled}
                            <NauiField label="Precio puja"
                                       className="mb-1"
                                       value={currency.format(item.bidPrice)}/>
                        {:else}
                            <NauiInput className="mb-1"
                                       label="Precio puja"
                                       type="number"
                                       on:input
                                       isDisabled={!editable || item.isDisabled}
                                       bind:value={item.bidPrice}/>
                        {/if}

                    </div>
                    <div>
                        <NauiField label="Descuento precio techo"
                                   className="mb-1"
                                   value={percent.format(item.discountCeilingPrice)}/>
                        <NauiField label="Descuento precio puja"
                                   className="mb-1"
                                   value={percent.format(item.discountBidPrice)}/>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="grid-2 gap-1">
                <div>
                    <div class="mb-iii" style="font-weight: 600">Precio a ofertar</div>
                    {#if !editable || item.isDisabled}
                        <NauiField label="Precio unitario"
                                   className="mb-1"
                                   value={currency.format(item.unitOfferPrice)}/>
                    {:else}
                        <NauiInput className="mb-1"
                                   alert={item.alert}
                                   type="number"
                                   label="Precio unitario"
                                   isDisabled={!editable || item.isDisabled}
                                   on:change={()=>dispatcher('update')}
                                   alertMessage={item.unitOfferErrorMessage}
                                   bind:value={item.unitOfferPrice}/>
                                   
                    {/if}
                    <NauiInput label="Precio UM"
                               className="mb-1"
                               isDisabled={!editable || item.isDisabled}
                               bind:value={item.muOfferPrice}/>
                    <NauiField label="Valor total oferta"
                               className="mb-1"
                               value={currency.format(item.totalValueOffer)}/>
                    <NauiField label="Precio mínimo"
                               className="mb-1"
                               value={currency.format(item?.product?.min_price||0)}/>
                    <NauiField label="Margen bruto %"
                               className="mb-1"
                               value={percent.format(item.margin / 100)}/>

                    {#if true && item.bu}
                        <div class="mt-1 flex">
                            <NauiTag label={item.bu?.name}
                                     backColor={item.bu?.color}
                                     borderColor={item?.bu?.color}
                                     textColor={item?.bu?.text_color}/>
                        </div>
                    {/if}
                </div>
                <div>
                    <div class="mb-iii" style="font-weight: 600">Costos</div>
                    <NauiField label="Costo unitario"
                               className="mb-1"
                               value={currency.format(item.unitCost)}/>
                    <NauiField label="Costo UM"
                               className="mb-1"
                               value={currency.format(item.muCost)}/>
                    <NauiField label="Costo Total Oferta"
                               className="mb-1"
                               value={currency.format(item.totalCost)}/>
                </div>
                <div class="col-2">
                    {#if !canApprove && item.approvalStatus}
                        <div class="box-l mb-1">
                            <div class="alert-status {item.approvalStatus.value}"
                                 on:click={showApproval}>
                                {item.approvalStatus.label}
                            </div>
                        </div>
                    {/if}

                    {#if item.alert || item.gunComment}
                        <NauiTextarea label="Observaciones del GUN"
                                      isDisabled={item.isDisabled}
                                      bind:value={item.gunComment}/>
                    {/if}
                    {#if canApprove}
                        {#if item.canApprove}
                            <div class="box-l sx-ii my-1">
                                <NauiButton caption="RECHAZAR"
                                            color="accent"
                                            mode="outline"
                                            on:click={reject}/>
                                <NauiButton caption="APROBAR"
                                            color="accent"
                                            mode="solid"
                                            on:click={approve}/>
                            </div>
                        {/if}
                    {/if}
                </div>
            </div>

        </div>
    </div>
    {#if item.alert}
        {#if item.toApprove}
            <div class="alert-price radius shadow">
                <i class="far fa-exclamation-triangle"></i>
                {item.errorMessageGUNPending}
            </div>
        {:else if item.showNewAlert}
            <div class="alert-price radius shadow">
                {@html item.alertMessages}
            </div>
        {/if}
    {/if}
</div>

<style>
    .alert-price {
        background-color: #FAFAFA;
        color: #04AA7C;
        padding: .75rem 1rem;
    }

    .alert-price i {
        margin-right: .25rem;
        color: #04AA7C;
    }

    .alert-status {
        background: #eee;
        color: #fff;
        padding: .2rem 1rem;
        font-weight: 900;
        border-radius: 20px;
        text-transform: uppercase;
    }

    .alert-status.rechazado {
        background: #F44336;
        cursor: pointer;
    }

    .alert-status.pendiente {
        background: #EAC705;
    }

    .alert-status.aprobado {
        background: #3F9C35;
        cursor: pointer;
    }

    .number {
        font-size: 23px;
        font-weight: 600;
        color: var(--primary);
        position: absolute;
    }
</style>
